var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    enableBackground: "new 0 0 14 13",
    xmlSpace: "preserve",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6386 2.81284C12.1624 -1.43264 7.36498 0.465342 6.92675 2.58808C6.32707 0.340475 1.64495 -1.33274 0.214944 2.81284C-1.37652 7.43293 6.3732 11.5785 6.92675 12.2528C7.4803 11.7034 15.23 7.35801 13.6386 2.81284Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.408cffc7f3c9b8f0cee81386b9a99967.svg";
export { ForwardRef as ReactComponent };